module.exports = __webpack_public_path__ + "static/media/kitty-pryde.d8d5b2cc.png";